import "./developerDashboard.scss";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DateBox from "devextreme-react/date-box";
import {
  getUserProjectMapping,
  getUserTicketStatusSummary,
  getUserTicketStatusSummaryByDate,
} from "../../api/dashboardApi";
import { PieChart, Series, Label, Legend } from "devextreme-react/pie-chart";
import {
  Chart,
  ArgumentAxis,
  ValueAxis,
  Series as ChartSeries,
} from "devextreme-react/chart";
import { ToastDisplayer } from "../../components/toastDisplay/ToastDisplayer";
import { useAuth } from "../../contexts/auth";
import CustomPageHeader from "../../components/customPageHeader/CustomPageHeader";
import { SubText } from "../../components/typographyText/TypographyText";

const DeveloperDashboard = () => {
  // current date for header
  const today = new Date().toLocaleDateString();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [assignmentData, setAssignmentData] = useState([]);
  const [ticketData, setTicketData] = useState([]);
  const [selectedFromDate, setSelectedFromDate] = useState(new Date());
  const [selectedToDate, setSelectedToDate] = useState(new Date());
  const [pendingTicket, setPendingTicket] = useState(0);
  const [cardData, setCardData] = useState({
    totalProjects: 0,
    assignedTickets: 0,
    resolvedTickets: 0,
    pendingTickets: 0,
  });

  const [totalTickets, setTotalTickets] = useState(0);

  // useEffect(() => {
  //   const fetchCustomerCount = async () => {
  //     console.log("Fetching customer count...");
  //     const count = await getCustomerCount();
  //     console.log("Fetched customer count:", count);
  //     setCustomerCount(count);
  //   };

  //   fetchCustomerCount();
  // }, []);

  //API to fetch Dashboard Data (developer project Count, assigned ticket and resolved ticket by developer)
  const fetchDashboardData = async () => {
    try {
      setLoading(true);

      const data = await getUserProjectMapping(
        user?.companytransid,
        user?.id || user?.usertransid,
      );

      if (data) {
        setCardData({
          totalProjects: data.total_selected_subcategories || 0,
          assignedTickets: data.assigned_ticket_count || 0,
          resolvedTickets: data.resolved_ticket_count || 0,
          pendingTickets: data.pending_ticket_count || 0,
        });
        setTotalTickets(data.total_ticket_count || 0);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      ToastDisplayer("error", "Error fetching dashboard data");
    }
  };
  //API to fetch Summary Status Data :
  const fetchSummaryData = async () => {
    try {
      const data = await getUserTicketStatusSummary(
        user?.companytransid,
        user?.id || user?.usertransid,
      );

      if (!data) return;
      setPendingTicket(data.pending_tickets);

      const formattedData = [
        // {
        //   label: "Total Tickets",
        //   value: data.total_tickets,
        //   color: "#555",
        // },
        // {
        //   label: "In Progress",
        //   value: data.resolved_tickets,
        //   color: statusColors["resolved"],
        // },
        // {
        //   label: "Pending",
        //   value: data.pending_tickets,
        //   color: statusColors["pending"],
        // },
        // {
        //   label: "Resolved",
        //   value: data.resolved_tickets,
        //   color: statusColors["resolved"],
        // },

        ...data.status_summary.map((item) => {
          const statusKey = item.status
            ? item.status.toLowerCase()
            : "no status";

          return {
            label: item.status || "No Status",
            value: item.count,
            color: statusColors[statusKey] || "#ccc",
          };
        }),
      ];
      // setTotalTickets(data.total_tickets || 0);

      setAssignmentData(formattedData);

      // ✅ ALSO update chart data (important fix)
      // setTicketData(data);
    } catch (error) {
      ToastDisplayer("error", "Error fetching summary data");
    }
  };

  useEffect(() => {
    fetchDashboardData();
    fetchSummaryData();
  }, []);

  const fetchSummaryDataByDate = async () => {
    try {
      if (!selectedFromDate || !selectedToDate) return;

      const formattedFromDate = selectedFromDate.toISOString().split("T")[0];
      const formattedToDate = selectedToDate.toISOString().split("T")[0];

      const res = await getUserTicketStatusSummaryByDate(
        user?.companytransid,
        user?.id || user?.usertransid,
        formattedFromDate,
        formattedToDate,
      );

      if (!res) return;

      // ✅ Update chart
      setTicketData(res);

      // // ✅ Update Assignment Card (IMPORTANT)
      // const formattedData = [
      //   {
      //     label: "Assign Tickets",
      //     value: res.total_tickets,
      //     color: "#555",
      //   },
      //   // ...res.status_summary.map((item) => {
      //   //   const statusKey = item.status
      //   //     ? item.status.toLowerCase()
      //   //     : "no status";

      //   //   return {
      //   //     label: item.status || "No Status",
      //   //     value: item.count,
      //   //     color: statusColors[statusKey] || "#ccc",
      //   //   };
      //   // }),
      // ];

      // setAssignmentData(formattedData);
    } catch (error) {
      ToastDisplayer("error", "Error fetching summary data by date");
    }
  };
  useEffect(() => {
    if (selectedFromDate && selectedToDate) {
      fetchSummaryDataByDate();
    }
  }, [selectedFromDate, selectedToDate]);

  const summaryData = [
    {
      title: "Total Assigned Ticket",
      value: cardData.assignedTickets,
      icon: "ri-ticket-2-line",
      iconColor: "#48A9A6",
    },
    {
      title: "Projects",
      value: cardData.totalProjects,
      icon: "ri-briefcase-line",
      iconColor: "#C1666B",
      route: "/Profile",
      section: "projects",
    },
    {
      title: "Pending",
      value: cardData.pendingTickets,
      icon: "ri-coupon-line",
      iconColor: "#03a9f4",
    },
    {
      title: "Resolved Tickets",
      value: cardData.resolvedTickets,
      icon: "ri-checkbox-circle-line",
      iconColor: "#48A9A6",
    },
  ];

  const handleFromDateChange = useCallback((e) => {
    setSelectedFromDate(e.value);
  }, []);

  const handleToDateChange = useCallback((e) => {
    setSelectedToDate(e.value);
  }, []);

  const handleReset = () => {
    setSelectedFromDate(new Date());
    setSelectedToDate(new Date());
  };
  // helper component for a summary card
  // const SummaryCard = ({ icon, title, value, iconColor }) => (
  //   <div className="card summary-card">
  //     {icon && (
  //       <i
  //         className={`icon ${icon}`}
  //         aria-hidden="true"
  //         style={{ color: iconColor || '#fff' }}
  //       />
  //     )}
  //    <h3>{loading ? "..." : value}</h3>
  //     <p>{title}</p>
  //   </div>
  // );

  const SummaryCard = ({ icon, title, value, iconColor, route, section }) => (
    <div
      className="card summary-card"
      onClick={() =>
        route && navigate(route, section ? { state: { section } } : {})
      }
    >
      {icon && (
        <i
          className={`icon ${icon}`}
          aria-hidden="true"
          style={{ color: iconColor || "#fff" }}
        />
      )}
      <h3>{loading ? "..." : value}</h3> {/* ← here */}
      <p>{title}</p>
    </div>
  );

  // Status Data Mapped Colors
  const statusColors = {
    open: "#C1666B",
    closed: "#48A9A6",
    pending: "#E8D5B7",
    resolved: "#95E1D3",
    "work in progress": "#F4A261",
    "in progress": "#F4A261",
    "not possible": "#9D4EDD",
    "no status": "#9e9e9e",
  };

  //Generate Pastel Colors Dynamically
  const generatePastelColors = (count) => {
    const colors = [];
    const baseHue = 200; // change this if you want different color family

    for (let i = 0; i < count; i++) {
      const hue = (baseHue + i * 40) % 360;
      colors.push(`hsl(${hue}, 60%, 75%)`);
    }

    return colors;
  };

  //Prepare Chart Data With Colors
  const statuses = ticketData?.status_summary || [];

  const pastelColors = generatePastelColors(statuses.length);

  const chartData = statuses.map((item, index) => ({
    ...item,
    color: pastelColors[index],
  }));

  const getFormattedDateLabel = () => {
    if (!selectedFromDate || !selectedToDate) return "";

    const format = (date) => new Date(date).toLocaleDateString("en-GB"); // dd/mm/yyyy

    const from = format(selectedFromDate);
    const to = format(selectedToDate);

    // ✅ If same date → show only one
    if (from === to) {
      return from;
    }

    // ✅ Else show range
    return `${from} - ${to}`;
  };

  return (
    <>
      <div className="wholePage">
        <div className="headerComponent">
          <div className="headerContainer1">
            <div className="title">
              <span class="icon-size">
                <i class="ri-line-chart-line"></i>
              </span>
              <p>My Dashboard</p>
            </div>
            <div className="totalTicketTitle">
              <SubText text={`Total ${totalTickets} tickets`} />
            </div>
          </div>
        </div>

        {/* ===== Main Section ===== */}
        <div className="dashboard-container">
          {/* ===== Header ===== */}
          {/* ===== Top Summary Cards ===== */}
          <div className="summary-cards">
            {summaryData.map((item, index) => (
              <SummaryCard
                key={index}
                icon={item.icon}
                iconColor={item.iconColor}
                title={item.title}
                value={item.value}
                route={item.route}
                section={item.section}
              />
            ))}
          </div>

          {/* ===== Main Section ===== */}
          <div className="dashboard-content ">
            {/* Ticket Status */}
            <div className="section1">
              <div className="filterField">
                <label className="filterLabel">From Date</label>

                <DateBox
                  // stylingMode="outlined"
                  displayFormat="dd-MM-yyyy"
                  // label="From Date"
                  type="date"
                  pickerType="calendar"
                  value={selectedFromDate || ""}
                  onValueChanged={handleFromDateChange}
                  max={new Date()}
                />
              </div>
              <div className="filterField">
                <label className="filterLabel">To Date</label>

                <DateBox
                  // stylingMode="outlined"
                  displayFormat="dd-MM-yyyy"
                  // label="To Date"
                  type="date"
                  pickerType="calendar"
                  value={selectedToDate || ""}
                  onValueChanged={handleToDateChange}
                  max={new Date()}
                  min={new Date(selectedFromDate)}
                />
              </div>
              <button className="reset-btn" onClick={handleReset}>
                Reset
              </button>{" "}
            </div>
            <div className="section2">
              <div className="card chart-card">
                <div className="card-header">
                  <h3>Ticket Status</h3>
                  <span className="small-label">
                    {getFormattedDateLabel() ===
                    new Date().toLocaleDateString("en-GB")
                      ? "Today"
                      : getFormattedDateLabel()}
                  </span>{" "}
                  {/* <span className="small-label">Today</span> */}
                  {/*<DateBox
              className="ticketStatusDateBox"
              value={selectedDate}
              stylingMode="outlined"
              type="date"
              displayFormat="dd/MM/yyyy"
              onValueChanged={(e) => {
                setSelectedDate(e.value);
              }}
              width={150}
            />
         */}
                </div>
                <div className="chart-with-legend">
                  <PieChart
                    key={ticketData?.total_tickets}
                    dataSource={chartData}
                    type="doughnut"
                    innerRadius={0.6}
                    customizePoint={(pointInfo) => {
                      return { color: pointInfo.data.color }; // use the color from each data item
                    }}
                    centerRender={() => (
                      <svg width="200" height="200">
                        <text
                          x="50%"
                          y="45%"
                          textAnchor="middle"
                          dominantBaseline="middle"
                          fontSize="22"
                          fontWeight="700"
                          fill="#111827"
                        >
                          {ticketData?.total_tickets || 0}
                        </text>
                        <text
                          x="50%"
                          y="60%"
                          textAnchor="middle"
                          dominantBaseline="middle"
                          fontSize="12"
                          fill="#6b7280"
                        >
                          Total Assign Tickets
                        </text>
                      </svg>
                    )}
                  >
                    <Series
                      argumentField="status"
                      valueField="count"
                      // Remove colorField – we now control colors via customizePoint
                    >
                      <Label visible={true} font={{ color: "#fff" }} />
                    </Series>
                    <Legend visible={false} />
                  </PieChart>

                  {/* custom legend */}
                  <div className="custom-legend">
                    {chartData?.map((item, idx) => (
                      <div key={idx} className="legend-row">
                        <span
                          className="color-box"
                          style={{ background: item.color }}
                        />
                        <span className="legend-text">
                          {item.status} ({item.count})
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Assignment Status */}
              <div className="card assignment-card">
                {/* <span className="small-label">Summary</span> */}
                <h3>Assignment Status</h3>

                {assignmentData.map((item, index) => {
                  const total = assignmentData[0]?.value || 1;
                  const pct = total
                    ? Math.round((item.value / total) * 100)
                    : 0;

                  return (
                    <div
                      key={index}
                      className="assignment-row"
                      style={{ "--row-color": item.color }}
                    >
                      <div className="row-header">
                        <span>
                          {item.label} : <strong>{item.value}</strong>
                        </span>
                      </div>

                      <div className="progress-bar-track">
                        <div
                          className="progress-bar-fill"
                          style={{ width: `${pct}%`, background: item.color }}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeveloperDashboard;
